<template lang="html">
  <div class="me-index">
    <div class="course-videos">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <van-sidebar v-model="activeKey" style="padding: 0rem 0.42667rem; width: 100%;" class="custom-subtitle">
          <van-sidebar-item title="目录"  />
        </van-sidebar>

        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
          <van-cell v-for="item in list" :key="item.id" >
            <van-card class="videos-card" @click="changeToCourse(item.id)">
              <template #thumb style="border-radius:0px;">
                <van-image  width="24vw" fit="cover"
                            :src="item.coverUrl.indexOf(',')>0 ? item.coverUrl.substring(0, item.coverUrl.indexOf(',')) : item.coverUrl"
                />
              </template>
              <template #desc>

                <div style="font-size: 0.4rem;font-weight: bold;"> {{ item.name }} </div>

                <div style="color: #1118;">
                  <span class="divider-tag ">{{item.lessonDate}}</span>
                  <span class="divider-tag divider-right">共有{{item.lessonSize}}节课</span>
                </div>
              </template>
            </van-card>
          </van-cell>
        </van-list>

      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      courseData: {},
      loading: false,
      finished: false,
      isLoading: false,
      page: {
        current: 1,
        size: 10
      },
      categoryId: '',
      searchKey:"",
      activeKey:0,
      activeName:0,
      commentData: [
      ],
      commendData: [
      ]
    }
  },
  mounted() {
   this.init();
  },
  methods: {
    changeToCourse(id){
      this.$router.push({
        path: '/wechat/openCourse/' + id
      })
    },
    init(){
      console.log(this.$router)
      const categoryId = this.$router.history.current.params.id;
      console.log(categoryId);
      this.categoryId = categoryId;
      this.$api.course.getPublishList({
        category: this.categoryId,
        ...this.page
      }).then((res) => {
        console.log(res);
        this.loading = false;
        if (res.code === 200){
          this.list = res.data.records;
          this.finished = true;
        }
      })
    },
    onRefresh() {
      if (!this.finished){
        this.page.current = this.page.current + 1;
        this.init();
      }
    },
    onClick(name, title) {
        console.log('click tab', name, title);
        switch(title) {
          case '目录':
            this.getCourseLessonList();
            break;
        }
    },
    getCourseLessonList(){
      this.$api.course.getPublishCourseLessonDetail({
        id: this.courseId
      }).then((res) => {
        console.log(res);
        if (res.code === 200){
          this.list = res.data
        }
      })
    },
    onLoad() {
      // if (!this.finished){
      //   this.page.current = this.page.current + 1;
      //   this.init();
      // }
    }
  }
}
</script>

<style lang="less" scoped>

.divider-tag{ padding-right:8px;  margin-right:8px; position: relative;}
[class*='divider-right']::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border-right: 1px solid #aaa8;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
}

.user-card{ padding:0px; background:#fff; }
.van-card__header{ }

.user-card .van-card__footer{ text-align:left;}
.user-card .van-card__thumb{ width:38%; max-width:150px; height:auto;}
.list-card{ padding:0; background:#fff; }


.list-card .van-card__header{ padding:0px; }
.list-card .van-card__thumb{ width:18vw; max-width:150px; height:auto;}

.course-info--ellipse{ background-color:#fff; padding:0;}
.course-info--ellipse .van-card__thumb{width:16vw;max-width:150px; height:auto;}



.videos-card{padding:0; background:#fff;}
.videos-card .van-card__header{ padding:0px; }
.videos-card .van-card__thumb{ width:24vw; max-width:150px; height:auto;}

/*购物车按钮*/
.van-goods-action-button--danger {
    background: -webkit-linear-gradient(left, #00b1d2, #0091AC);
    background: linear-gradient(to right, #00b1d2, #0091AC);
}


.van-card__footer .van-button{ margin-left:0;}

.van-sidebar-item{ padding:0.5rem 0.32rem;font-size:0.5rem;}

.custom-collapse{ text-align:center;}
.custom-collapse-item { display:inline-block;color:#888; }


#container{
  width: 100%;
  z-index: 1;
  min-height: 100vh;
  &:hover {
    cursor: pointer;
  }
}
.list-caontainer {
  margin-bottom: 1.2rem;
}
  .search-icon {
    font-size: .3rem;
    line-height: inherit;
  }
  .van-card__content{ min-height:1rem;}
</style>
<style>
.van-cell--clickable:active {
    background-color: #fff;
}

.custom-collapse-item .van-cell{  width:fit-content; margin:0 auto;}
.custom-collapse-item .van-cell__title,.custom-collapse-item .van-cell__right-icon{ color: #1114; }
.custom-collapse-item .van-cell__right-icon{  }

.van-goods-action-icon__icon{font-size:0.5rem;}
.custom-subtitle{overflow-y: unset;}
</style>
